import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import  ssoLogin from 'ssoLogin';
import  ssoRegister from 'ssoRegister';
import  ssoFindPassword from 'ssoFindPassword';

// 定义路由
const routes = [
	{
		path:'/',
		component:ssoLogin
	},
	{
		path:'/login',
		component:ssoLogin
	},
	{
		path:'/register',
		component:ssoRegister
	},
	{
		path:'/findPassword',
		component:ssoFindPassword
	},
	{
		path: '/*',
		component: ssoLogin
	}
];

// 创建路由实例
const router = new VueRouter({
	routes
})


module.exports = router;



// WEBPACK FOOTER //
// ./src/service/sso/sso.router.js